import { Input as ChordsInput, type InputProps } from '~/chords/Input';

import { withClassNameHoc } from '../WithClassNameHoc';

export const Input = withClassNameHoc(ChordsInput);
Input.displayName = 'Input';

export type { InputProps };
